import { cn } from "@/utils/classes";
import React, { ReactNode } from "react";

/* Prop Types */
interface SelectProps {
  value?: string;
  onChange: (value: string) => void;
  children: ReactNode;
  defaultValue?: string;
  className?: string;
  variant?: "ghost" | "bordered";
  disabled?: boolean;
}

/*
 * Select component
 */
export const Select: React.FC<SelectProps> = ({ value, onChange, children, defaultValue, className, variant = "ghost", disabled = false }) => {
  /* Render */
  return (
    <select
      className={cn(
        "select min-h-10 h-10 max-h-10 focus:outline-base-200",
        {
          "select-ghost": variant === "ghost",
        },
        className,
      )}
      onChange={(e) => onChange(e.target.value)}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
    >
      {children}
    </select>
  );
};
